/** 金額に端数を切り捨てコンマを追加する */
export const priceWithComma = (_price: number): string => {
  return Math.floor(_price).toLocaleString()
}
